import { render, staticRenderFns } from "./Customers _copy.vue?vue&type=template&id=a9a13b3a"
import script from "./Customers _copy.vue?vue&type=script&lang=js"
export * from "./Customers _copy.vue?vue&type=script&lang=js"
import style0 from "./Customers _copy.vue?vue&type=style&index=0&id=a9a13b3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports